// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/search/hotel_result.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_feature_hotel_hotel_offer } from "../feature/hotel/hotel_offer_pb";

/**
 * Describes the file proto/model/search/hotel_result.proto.
 */
export const file_proto_model_search_hotel_result = /*@__PURE__*/
  fileDesc("CiVwcm90by9tb2RlbC9zZWFyY2gvaG90ZWxfcmVzdWx0LnByb3RvEgZjYXJtZW4iNgoLSG90ZWxSZXN1bHQSJwoLaG90ZWxfb2ZmZXIYASABKAsyEi5jYXJtZW4uSG90ZWxPZmZlckIoWiZnaXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbGIGcHJvdG8z", [file_proto_model_feature_hotel_hotel_offer]);

/**
 * Describes the message carmen.HotelResult.
 * Use `create(HotelResultSchema)` to create a new message.
 */
export const HotelResultSchema = /*@__PURE__*/
  messageDesc(file_proto_model_search_hotel_result, 0);

